export const ADMIN_ROLE = "admin";
export const PARTNER_ROLE = "partner";
export const PARTNER_ADMIN_HOME = "/admin/dream/operations";

const PARTNER_ALLOWED_PATHS = [
  "/admin/dream",
  "/admin/dream-users",
  "/admin/customer-voice",
];

export function isAdminRole(user) {
  return user?.role === ADMIN_ROLE;
}

export function isPartnerRole(user) {
  return user?.role === PARTNER_ROLE;
}

export function isAdminWebRole(user) {
  return isAdminRole(user) || isPartnerRole(user);
}

export function canManageDream(user) {
  return isAdminRole(user) || isPartnerRole(user);
}

export function getAdminHomePath(user) {
  return isPartnerRole(user) ? PARTNER_ADMIN_HOME : "/admin";
}

export function canPartnerAccessPath(pathname) {
  return PARTNER_ALLOWED_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`)
  );
}

export function canAccessAdminPath(user, pathname) {
  if (isAdminRole(user)) return true;
  if (!isPartnerRole(user)) return false;
  return canPartnerAccessPath(pathname);
}

export function getAdminRoleLabel(user) {
  if (isPartnerRole(user)) return "협력업체";
  return "관리자";
}
